export default function RefreshIcon() {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M4.64372 12C4.64372 15.3137 7.33002 18 10.6437 18C12.6857 18 14.4894 16.9799 15.5731 15.4216C15.7307 15.195 16.0347 15.1118 16.2737 15.2498C16.5131 15.3879 16.5964 15.6953 16.4413 15.924C15.1825 17.7803 13.0555 19 10.6437 19C6.77773 19 3.64372 15.866 3.64372 12C3.64372 8.13401 6.77773 5 10.6437 5C13.8766 5 16.5977 7.19162 17.4021 10.1702L18.0347 8.56524C18.1359 8.30833 18.4263 8.18215 18.6832 8.2834C18.9401 8.38466 19.0663 8.67501 18.965 8.93192L17.865 11.723C17.7638 11.9799 17.4734 12.1061 17.2165 12.0048L14.4255 10.9048C14.1685 10.8035 14.0424 10.5132 14.1436 10.2563C14.2449 9.99935 14.5352 9.87317 14.7921 9.97442L16.4897 10.6435C15.8749 7.98316 13.4909 6 10.6437 6C7.33002 6 4.64372 8.68629 4.64372 12Z"
        fill="#262E3D"
        fillOpacity="0.67"
      />
    </svg>
  );
}
